import { Button } from 'components/atoms'
import { EFilterDateAuto } from 'enums'
import { IPeriodTime } from 'interfaces'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { getTimeMonth, getTimeToday, getTimeWeek } from 'utils'

const StyledBtnFilter = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  gap: 8px;
`
interface IProps {
  onSearch?: (periodTime: IPeriodTime) => void
  onChange?: (filterDate: EFilterDateAuto) => void
  filterSelected?: EFilterDateAuto
  defaultSelected?: EFilterDateAuto
}
const FilterDateWeekMonth = (props: IProps) => {
  const { onChange, onSearch, filterSelected } = props
  const { t } = useTranslation()

  const handleOnChange = (filterType: EFilterDateAuto) => {
    if (onChange) onChange(filterType)
    switch (filterType) {
      case EFilterDateAuto.ToDay:
        if (onSearch) onSearch(getTimeToday())
        break
      case EFilterDateAuto.ToWeek:
        if (onSearch) onSearch(getTimeWeek())
        break
      case EFilterDateAuto.ToMonth:
        if (onSearch) onSearch(getTimeMonth())
        break
    }
  }
  return (
    <StyledBtnFilter>
      <Button
        color="blue"
        btnOutline={filterSelected !== EFilterDateAuto.ToDay}
        onClick={() => handleOnChange(EFilterDateAuto.ToDay)}>
        {t('today')}
      </Button>
      <Button
        color="blue"
        btnOutline={filterSelected !== EFilterDateAuto.ToWeek}
        onClick={() => handleOnChange(EFilterDateAuto.ToWeek)}>
        {t('this-week')}
      </Button>
      <Button
        color="blue"
        btnOutline={filterSelected !== EFilterDateAuto.ToMonth}
        onClick={() => handleOnChange(EFilterDateAuto.ToMonth)}>
        {t('this-month')}
      </Button>
    </StyledBtnFilter>
  )
}

export default FilterDateWeekMonth
